import React from 'react'

export default function ExplorerIcon({ className, size = 48 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="32" cy="32" r="30" fill="url(#explorer-bg)" opacity="0.2" />
      <defs>
        <linearGradient id="explorer-bg" x1="0" y1="0" x2="64" y2="64">
          <stop offset="0%" stopColor="#667eea" />
          <stop offset="100%" stopColor="#764ba2" />
        </linearGradient>
        <linearGradient id="explorer-main" x1="0" y1="0" x2="64" y2="64">
          <stop offset="0%" stopColor="#f093fb" />
          <stop offset="100%" stopColor="#f5576c" />
        </linearGradient>
        <linearGradient id="explorer-accent" x1="0" y1="0" x2="64" y2="64">
          <stop offset="0%" stopColor="#ffd89b" />
          <stop offset="100%" stopColor="#19547b" />
        </linearGradient>
      </defs>
      
      {/* Телескоп - основная труба */}
      <rect
        x="18"
        y="28"
        width="32"
        height="8"
        rx="2"
        fill="url(#explorer-main)"
        transform="rotate(-25 32 32)"
      />
      
      {/* Окуляр */}
      <circle
        cx="20"
        cy="38"
        r="4"
        fill="url(#explorer-accent)"
        opacity="0.8"
      />
      
      {/* Линза */}
      <circle
        cx="44"
        cy="22"
        r="5"
        fill="url(#explorer-accent)"
        opacity="0.6"
      />
      <circle
        cx="44"
        cy="22"
        r="3"
        fill="#1a1a2e"
        opacity="0.4"
      />
      
      {/* Штатив - ножки */}
      <path
        d="M28 36 L22 48"
        stroke="url(#explorer-main)"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M32 38 L32 50"
        stroke="url(#explorer-main)"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M36 36 L42 48"
        stroke="url(#explorer-main)"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      
      {/* Соединение штатива */}
      <circle cx="32" cy="38" r="3" fill="url(#explorer-accent)" />
      
      {/* Звезды (что открывает исследователь) */}
      <path
        d="M50 14 L51 16 L53 16 L51.5 17.5 L52 19 L50 18 L48 19 L48.5 17.5 L47 16 L49 16 Z"
        fill="url(#explorer-accent)"
        opacity="0.8"
      />
      <circle cx="52" cy="28" r="1.5" fill="#ffd89b" opacity="0.7" />
      <circle cx="48" cy="12" r="1" fill="#ffd89b" opacity="0.6" />
    </svg>
  )
}
